import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Nshock } from '../nshock';


@Component({
    selector: 'nsm1',
    templateUrl: './nsm1.component.html',
    styleUrl: './nsm1.component.scss',
    standalone: false
})
export class Nsm1Component {


  m1Form: FormGroup | undefined;
  m1Bool?: boolean;
  m1Shock: Nshock | undefined;


  constructor(private fBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.m1Form = this.fBuilder.group({
      gammaVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
      ]],
      m1Val: ['', [
        Validators.required,
        Validators.min(1)
      ]]
    })
  }

  onSubmit(): void {
    this.m1Bool = true;
    this.m1Shock = new Nshock();
    this.m1Shock.gammaVal = this.m1Form?.get('gammaVal')?.value;
    this.m1Shock.m1 = this.m1Form?.get('m1Val')?.value;
    this.m1Shock.nShockCalc(this.m1Shock.gammaVal, this.m1Shock.m1);
  }

  nsm2() {
    return this.m1Shock?.m2; 
  }

  nsp2p1() {
    return this.m1Shock?.p2p1;
  }

  nst2t1() {
    return this.m1Shock?.t2t1;
  }

  nsdva1() {
    return this.m1Shock?.dva1;
  }

  nspt2_pt1() {
    return this.m1Shock?.pt2pt1;
  }

  nspt2_p1() {
    return this.m1Shock?.pt2p1;
  }

}
